<template>
    <div class="modal-mask new-background-modal">
        <a  class="modal-default-button" @click="servicesClosePlatform() ">
            <img src="../assets/images/modal/close.svg" alt="CiBeez"/>
        </a>
        <div data-aos="fade" data-aos-duration="3000"  class="modal-wrapper container">
            <div class="modal-container row">
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                    <h3 class="title-modal">A ground-breaking Delivery-as-a-Service platform</h3>
                    <p class="font_7 font">
                        <span>
                            Reinvent and reshape delivery management providing full automation and dynamic optimization of complex delivery models, for the last-mile market
                        </span>
                    </p>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                    <ul class="modal-list">
                        <li>Reduce costs and investments by applying fully automated, optimized, scalable, cloud based, state of the art solution </li>
                        <li>Increase top-line by having higher delivery throughput applying cutting edge optimization  algorithms that maximize your fleet delivery </li>
                        <li>Improve customer satisfaction and experience</li>
                        <li>Provide accurate ETA and real-time information</li>
                        <li>Offer flexible and nimble processing of customer’s varying demands</li>
                        <li>Deliver customer experience and simple and efficient interaction through app and notification</li>
                    </ul>
                </div>
                <div class="font_7">
                    The only platform in the market to provide end-2-end automation and dynamic optimization with AI capabilities ready for autonomous cars and droids
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        methods: {
            servicesClosePlatform() {
                this.$emit('servicesClosePlatform')
            }
        }
    }
</script>
